import {
  useEffect,
  useState,
  Suspense,
  lazy,
  useRef,
  useCallback,
} from "react";
import "./App.scss";
import "./Views/Admin/analytics.css";
import { useSelector } from "react-redux";
import "./i18n";
import { Box, Typography } from "@mui/material";
import { Routes, Route, useLocation, useSearchParams } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Header from "./components/header/Header";
import LoginScreen from "./Screen/Auth/LoginScreen";
import SignupScreen from "./Screen/Auth/SignupScreen";
import ResetPasswordScreen from "./Screen/Auth/ResetPasswordScreen";
import ChooseProfileScreen from "./Screen/Auth/ChooseProfileScreen";
import PrivateRoutes from "./routes/PrivateRoutes";
import AuthHandlerRoutes from "./routes/AuthHandlerRoutes";
import ProfileScreen from "./Screen/Profile/ProfileScreen";
import PujaScreen from "./Screen/Puja/PujaScreen";
import TempleScreen from "./Screen/Temple/TempleScreen";
import PersonalInfoScreen from "./Screen/Profile/Screen/PersonalInfo/PersonalInfoScreen";
import AddressScreen from "./Screen/Profile/Screen/Address/AddressScreen";
import TempleDetailsScreen from "./Screen/Temple/TempleDetailsScreen";
import VirtualPujaBookingScreen from "./Screen/Puja/VirtualPoojaBookingScreen";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AboutUsScreen from "./Screen/AboutUs/AboutUsScreen";
import MyOrdersScreen from "./Screen/MyOrders/MyOrdersScreen";
import CheckUserFromOAuth from "./handlers/AuthReload";
import LoadInitialData from "./handlers/LoadInitialData";

import PujaInfoScreen from "./Screen/Puja/PujaInfoScreen";
import PanchangScreen from "./Screen/Panchang/PanchangScreen";
import ShaktipethaScreen from "./Screen/Temple/ShaktipethaScreen";
import PromotioanlPujaScreen from "./Screen/Puja/PromotionalPujaScreen";
import LiveDarshanScreen from "./Screen/LiveDarshan/LiveDarshanScreen";
import LiveDarshanVideoScreen from "./Screen/LiveDarshan/LiveDarshanVideoScreen";
import SearchScreen from "./Screen/Search/SearchScreen";
import SkeletonAnimations from "./components/Other/SkeletonAnimations";
import {
  formatNumber,
  getCurrentPosition,
  getRandomNumber,
  logger,
} from "./utils/HelperFunctions";

import ChadhavaScreen from "./Screen/Chadhava/ChadhavaScreen";
import ChadhavaDetailsScreen from "./Screen/Chadhava/ChadhavaDetailsScreen";
import HoroscopeScreen from "./Screen/Horoscope/HoroscopeScreen";
import HoroscopeDetailsScreen from "./Screen/Horoscope/HoroScopeDetailsScreen";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import PujaStepsScreen from "./Screen/PujaSteps/PujaStepsScreen";
import CheckoutV2Screen from "./Screen/CheckoutV2/CheckoutV2Screen";
import AddDevoteeDetailsScreen from "./Screen/CheckoutV2/AddDevotee/AddDevoteeScreen";
import ReviewCartScreen from "./Screen/CheckoutV2/ReviewCart/ReviewCartScreen";
import BackToTop from "./components/BackToTopBtn/BackToTop";

import EventScreen from "./Screen/Event/EventScreen";
import AIGurujiLoginDialog from "./components/dialog/AIGurujiLoginDialog";
import { setMessageToReactNative } from "./utils/WebNativeFunctions";
import {
  checkUserDetails,
  logoutAction,
  registerWebPushToken,
} from "./store/actions/authAction";
import PrasadDetailsScreen from "./Screen/Prasad/PrasadDetailsScreen";
import PrasadScreen from "./Screen/Prasad/PrasadScreen";
import GlobalSearchScreen from "./Screen/GlobalSearch/GlobalSearchScreen";
import PromotionalChadhavaScreen from "./Screen/Chadhava/PromotionalChadhavaScreen";
import { useTranslation } from "react-i18next";
import { LOCALIZATION } from "./utils/localization";
import { LOCALSTORAGE_KEY, metaTempleImg } from "./utils/Constants";
import { v4 as uuidv4 } from "uuid";
import PujaSubCategoriesScreen from "./Screen/Puja/PujaSubCategoriesScreen";
import AboutScreen from "./Screen/About/AboutScreen";
import "react-lazy-load-image-component/src/effects/blur.css";
import {
  mergeUserAndGuestCart,
  updateCartAction,
} from "./store/actions/cartAction";
import HelmetComponent from "./components/Shared/HelmetComponent";
import WalletModal from "./components/WalletDialog/WalletModal";
import { fetchWalletBalanceAction } from "./store/actions/walletAction";

import OfflineDetector from "./components/offlinedetector/OfflineDetector";
import OffLineScreen from "./Screen/Offline/OffLineScreen";
import PujaPackageInfoscreen from "./Screen/PujaPackage/PujaPackageInfoscreen";
import ChadavaPackageInfoScreen from "./Screen/ChadavaPackage/ChadavaPackageInfoScreen";
import HomeSkeleton from "./components/Other/HomeSkeleton";
import "./styles/react-multi-carousel-fix.css";
import { PUJA_LIST_SCHEMA, PUJA_SCHEMA } from "./configs/seoConfig";
import { SESSION_STORAGE_KEY } from "./utils/analyics/analyticsConstant";
import {
  getBrowserFromUAData,
  getExternalEntryPoint,
  getIsoTimestamp,
  getOSInfo,
  trackCleavertapEvent,
} from "./utils/analyics/analyticsHelper";
import { ANALYTICS_EVENTS } from "./utils/analyics/analyticsEvents";
import usePageVisitCounter from "./hooks/usePageVisitCounter";
import PageViewTracker from "./components/analytics/PageViewTracker";
import PagePerformanceTracker from "./components/analytics/PagePerformanceTracker";
import ScrollTracker from "./components/analytics/ScrollTracker";
import { getMessagingInstance, requestForToken } from "./firebaseService";
import { onMessage } from "firebase/messaging";
import { VoiceBotTriggerButton } from "./components/VoiceBot/VoiceBotTriggerButton";
import { setNavigatedFromToLogin } from "./store/slices/analyticsSlice";
const PrivacyPolicyScreen = lazy(
  () => import("./Screen/PrivacyPolicy/PrivacyPolicyScreen"),
);
const PageLinkScreen = lazy(() => import("./Screen/PageLink/PageLinkScreen"));
const TermsAndConditionsScreen = lazy(
  () => import("./Screen/TermsAndConditions/TermsAndConditionsScreen"),
);
const ContactUsScreen = lazy(
  () => import("./Screen/ContactUs/ContactUsScreen"),
);

const RefundsCancellationsScreen = lazy(
  () => import("./Screen/RefundsCancellations/RefundsCancellationsScreen"),
);
const CommunityGuidelinesScreen = lazy(
  () => import("./Screen/CommunityGuidelines/CommunityGuidelinesScreen"),
);
const ErrorScreen = lazy(() => import("./Screen/Error/ErrorScreen"));
const SuccessScreen = lazy(() => import("./Screen/Success/SuccessScreen"));
const HomeScreen = lazy(() => import("./Screen/Home/HomeScreen"));
const GurujiScreen = lazy(() => import("./Screen/Guruji/GurujiScreen"));
const ValmikiVoiceBotModal = lazy(
  () => import("./components/VoiceBot/ValmikiVoiceBotModal"),
);

// 🧩 Lazy Imports for major route modules
const AdminHandlerRoutes = lazy(() => import("./routes/AdminHandlerRoutes"));

//const TermsAndConditionsScreen = lazy(() => import());

function App() {
  var { userInfo } = useSelector((state: any) => state.user);
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [isMobileView, setIsMobileView] = useState(false);
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [isVoiceBotOpen, setVoiceBotOpen] = useState(false);
  const [isShowAlertForLogin, setShowAlertForLogin] = useState(false);
  const userInfoRef = useRef(userInfo);

  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  // Helper to reliably check authentication status from Redux state and persistent storage
  const isUserLoggedIn = (user?: any) => {
    const checkUser = user || userInfoRef.current;
    if (checkUser && (checkUser.id || checkUser.phoneNumber)) {
      return true;
    }
    const storedUserRaw = localStorage.getItem(LOCALSTORAGE_KEY.USERINFO);
    if (
      storedUserRaw &&
      storedUserRaw !== "null" &&
      storedUserRaw !== "undefined"
    ) {
      try {
        const parsed = JSON.parse(storedUserRaw);
        return Boolean(parsed && (parsed.id || parsed.phoneNumber));
      } catch (e) {
        return false;
      }
    }
    return false;
  };

  const handleVoiceBotClick = useCallback(() => {
    if (isUserLoggedIn(userInfoRef.current)) {
      setVoiceBotOpen(true);
      setShowAlertForLogin(false);
    } else {
      setShowAlertForLogin(true);
    }
  }, []);

  const closeAlertForLogin = (type: string) => {
    setShowAlertForLogin(false);
    setMessageToReactNative(
      JSON.stringify({ isCloseVoiceBot: true, isCloseAIChat: true }),
    );
    if (type === "close" && location.pathname === "/ai-valmiki") {
      navigate("/");
    }
  };

  const handleVoiceBotClose = useCallback(() => {
    setVoiceBotOpen(false);
    setMessageToReactNative(
      JSON.stringify({ isCloseVoiceBot: true, isCloseAIChat: true }),
    );
    if (location.pathname === "/ai-valmiki") {
      navigate("/");
    }
  }, [location.pathname, navigate]);

  // Outbound message to React Native when Voice Bot opens
  useEffect(() => {
    if (isVoiceBotOpen) {
      setMessageToReactNative(
        JSON.stringify({ isVoiceBot: true, isChatWindow: true }),
      );
    }
  }, [isVoiceBotOpen]);

  // Listen for openVoiceBot event (e.g. upon clicking Valmiki in mobile/tablet bottom navigation)
  useEffect(() => {
    const handleOpenVoiceBotEvent = () => {
      handleVoiceBotClick();
    };
    window.addEventListener("openVoiceBot", handleOpenVoiceBotEvent);
    return () => {
      window.removeEventListener("openVoiceBot", handleOpenVoiceBotEvent);
    };
  }, [handleVoiceBotClick]);

  // Open Voice Bot when navigating to /ai-valmiki
  useEffect(() => {
    if (location.pathname === "/ai-valmiki") {
      handleVoiceBotClick();
    }
  }, [location.pathname, handleVoiceBotClick]);

  // Automatically reopen Voice Bot after successful login
  useEffect(() => {
    const loggedIn = isUserLoggedIn(userInfo);
    const isAuthRoute =
      location.pathname === "/login" || location.pathname === "/choose-profile";

    if (loggedIn && !isAuthRoute) {
      if (
        localStorage.getItem("autoOpenVoiceBot") === "true" ||
        localStorage.getItem("autoOpenAIGuruji") === "true"
      ) {
        localStorage.removeItem("autoOpenVoiceBot");
        localStorage.removeItem("autoOpenAIGuruji");
        setShowAlertForLogin(false);
        setTimeout(() => {
          setVoiceBotOpen(true);
        }, 350);
      }
    }
  }, [userInfo, location.pathname]);

  const [liveCount, setLiveCount] = useState(getRandomNumber());
  const [selectedMobileLanguage, setSelectedMobileLanguage] = useState("");
  const [mobileLocation, setMobileLocation] = useState();
  const [searchParams] = useSearchParams();
  const sessionStartedRef = useRef<boolean>(false);
  const ln = searchParams.get("ln")
    ? searchParams.get("ln")
    : (localStorage?.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en");

  // Page visit tracking for analytics
  usePageVisitCounter();

  useEffect(() => {
    CheckUserFromOAuth(dispatch);
    LoadInitialData(dispatch);

    function handleEvent(message: any) {
      let data = message?.data;
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (e) {
          // not json
        }
      }

      console.log("--4754--data-from-mobile-msg-",data)

      if (data?.isVoiceBot || data?.isChatWindow) {
        setIsMobileView(true);
        if (data.phoneNumber) {
          dispatch(checkUserDetails(data.phoneNumber));
        }
        if (
          data.language &&
          (data.language === "EN" ||
            data.language === "HI" ||
            data.language === "BN")
        ) {
          const mobileLang =
            data.language === "BN" ? "EN" : data.language;
          setSelectedMobileLanguage(mobileLang);
        }
        if(data?.userLocation){
          setMobileLocation(data?.userLocation ?? null);
        }
        setVoiceBotOpen(true);
      } else if (data?.loginFromMobile) {
        setIsMobileView(true);
        if (data.phoneNumber) {
          dispatch(checkUserDetails(data.phoneNumber));
        }
      } else if (data?.logoutFromMobile) {
        dispatch(logoutAction());
      }
    }

    document.addEventListener("message", handleEvent);
    window.addEventListener("message", handleEvent);
    const interval = setInterval(() => {
      setLiveCount(getRandomNumber());
    }, 120000);
    return () => {
      clearInterval(interval);
      document.removeEventListener("message", handleEvent);
      window.removeEventListener("message", handleEvent);
    };
  }, [dispatch]);

  useEffect(() => {
    if (ln) {
      i18n.changeLanguage(ln);
      localStorage.setItem(LOCALSTORAGE_KEY.LANG_CODE, ln);
    }
  }, [ln]);

  useEffect(() => {
    let timeConst: any = null;
    const getCoordinates = () => {
      const addressPermissionForPages = ["/", "/panchang"];
      if (
        addressPermissionForPages.includes(location.pathname) ||
        /^\/chadhavaDetails\/[^/]+$/.test(location.pathname)
      ) {
        getCurrentPosition(dispatch);
      }
      if (location.pathname === "/ai-valmiki") {
        handleVoiceBotClick();
      }
    };
    timeConst = setTimeout(() => {
      getCoordinates();
    }, 1500);
    return () => {
      if (timeConst) {
        clearTimeout(timeConst);
      }
    };
  }, [userInfo, location.pathname]);

  useEffect(() => {
    let timeConst: any = null;
    const subscribeToCart = async () => {
      try {
        const { CartService } = await import("td_server/services");
        if (userInfo?.phoneNumber) {
          const unsubscribe = CartService?.subscribeToCart(
            userInfo?.phoneNumber,
            (cartData: any) => {
              dispatch(updateCartAction(cartData?.items));
            },
          );
          // here add logic to add cart of guest user to loggedin user:
          let guestCartId = localStorage.getItem(LOCALSTORAGE_KEY.GUESTCARTID);
          if (guestCartId) {
            dispatch(mergeUserAndGuestCart(userInfo?.phoneNumber, guestCartId));
          }
          return () => unsubscribe(); // Unsubscribe when component unmounts
        } else {
          let guestCartId = localStorage.getItem(LOCALSTORAGE_KEY.GUESTCARTID);

          if (!guestCartId) {
            guestCartId = uuidv4(); // Create new guest cart ID
            localStorage.setItem(LOCALSTORAGE_KEY.GUESTCARTID, guestCartId);
          }
          localStorage.setItem(LOCALSTORAGE_KEY.GUESTCARTID, guestCartId);
          const unsubscribe = CartService?.subscribeToCart(
            guestCartId,
            (cartData: any) => {
              dispatch(updateCartAction(cartData?.items));
            },
          );
          return () => unsubscribe();
        }
      } catch (e: any) {
        console.error("Subscribe to cart error", e);
      }
    };
    if (userInfo?.id) {
      const token = localStorage.getItem(LOCALSTORAGE_KEY.WEB_PUSH_TOKEN);
      if (token) {
        dispatch(registerWebPushToken(userInfo?.id, token));
        // Subscribe the token to the "all" FCM topic
        import("td_server/services").then(({ PushNotificationService }) => {
          PushNotificationService.subscribeToFCMTopic(token, "allDevices")
            .then((res: any) => logger("Subscribed to FCM topic 'all':", res))
            .catch((err: any) => logger("FCM topic subscription failed:", err));
        });
      }
    }
    timeConst = setTimeout(() => {
      subscribeToCart();
    }, 1500);
    return () => {
      if (timeConst) {
        clearTimeout(timeConst);
      }
    };
  }, [userInfo?.phoneNumber]);

  useEffect(() => {
    const userId = userInfo?.id || userInfo?._id;
    if (userId) {
      dispatch(fetchWalletBalanceAction(userId));
    }
  }, [userInfo?.id, userInfo?._id, dispatch]);

  useEffect(() => {
    const startSessionTracking = async () => {
      if (sessionStartedRef.current) return;
      sessionStartedRef.current = true;

      sessionStorage.setItem(
        SESSION_STORAGE_KEY.SESSION_START_TIME,
        getIsoTimestamp(),
      );

      const browserData = getBrowserFromUAData();
      const osInfo = await getOSInfo();

      const payload = {
        User_ID: userInfo?.id ?? "guest_user",
        Device_Type: osInfo.Device_Type,
        OS: osInfo.OS,
        OS_Version: osInfo.OS_Version,
        Browser: browserData.Browser,
        Browser_Version: browserData.Browser_Version,
        Install_Source: "web",
      };

      trackCleavertapEvent(ANALYTICS_EVENTS.Session_Start, payload);
    };

    startSessionTracking();

    const sendSessionEnd = (reason: string) => {
      const sessionStartIso = sessionStorage.getItem("SESSION_START_TIME");

      const durationSeconds = sessionStartIso
        ? Math.floor((Date.now() - Date.parse(sessionStartIso)) / 1000)
        : 0;

      trackCleavertapEvent(ANALYTICS_EVENTS.Session_End, {
        User_ID: userInfo?.id ?? "guest_user",
        Session_Duration_Seconds: durationSeconds,
        Pages_Visited: Number(
          sessionStorage.getItem(SESSION_STORAGE_KEY.PAGE_VISIT_COUNT) || 0,
        ),
        Exit_Page: window.location.pathname,
        Exit_Reason: reason,
        Platform: "web",
      });
    };

    window.addEventListener("beforeunload", () => sendSessionEnd("user_quit"));

    return () => {
      window.removeEventListener("beforeunload", () =>
        sendSessionEnd("user_quit"),
      );
    };
  }, []);

  useEffect(() => {
    let unsubscribe: (() => void) | undefined;

    const initializeFCM = async () => {
      // 1. Check if Firebase Messaging is supported in this environment
      const messagingInstance = await getMessagingInstance();
      if (!messagingInstance) {
        console.log("Firebase Messaging not supported — skipping FCM setup.");
        return;
      }

      // 2. Request notification permission and get token
      if ("Notification" in window) {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          const token = await requestForToken();
          if (token) {
            localStorage.setItem(LOCALSTORAGE_KEY.WEB_PUSH_TOKEN, token);
          }
        } else {
          console.log("Notification permission denied by user.");
        }
      }

      // 3. Listen for foreground messages (INSIDE the async guard)
      unsubscribe = onMessage(messagingInstance, (payload: any) => {
        // 1. Safely extract data from payload
        // (Checks both .data and .notification fallback blocks depending on your backend payload)
        const title =
          payload?.data?.title || payload?.notification?.title || "New Update";
        const body = payload?.data?.body || payload?.notification?.body || "";
        const iconUrl = "/temple-logo-icon.webp";
        const imageUrl = payload?.data?.imageUrl || null;
        const notificationTag = payload?.data?.tag || "single-app-alert-tag";

        // 3. Trigger the NATIVE browser notification via the active Service Worker
        if (
          Notification.permission === "granted" &&
          "serviceWorker" in navigator
        ) {
          navigator.serviceWorker.ready.then((registration) => {
            registration.showNotification(title, {
              body: body,
              icon: imageUrl || iconUrl,
              badge: "/temple-logo-icon.webp",
              image: imageUrl,
              tag: notificationTag,
              requireInteraction: true,
              data: {
                ...payload?.data,
              },
            });
          });
        }
      });
    };

    initializeFCM();

    return () => {
      unsubscribe?.();
    };
  }, []);

  // Listen for navigation messages from the service worker (fallback when client.navigate() fails)
  useEffect(() => {
    const handleSWMessage = (event: MessageEvent) => {
      if (
        event.data?.type === "NOTIFICATION_CLICK_NAVIGATE" &&
        event.data?.url
      ) {
        const url = event.data.url;
        try {
          // Convert absolute URL to relative path for React Router
          const parsed = new URL(url, window.location.origin);
          navigate(parsed.pathname + parsed.search + parsed.hash);
        } catch {
          navigate(url);
        }
      }
    };

    navigator.serviceWorker?.addEventListener("message", handleSWMessage);
    return () => {
      navigator.serviceWorker?.removeEventListener("message", handleSWMessage);
    };
  }, [navigate]);

  const hostname =
    window.location.hostname === "localhost"
      ? "http://localhost:3000"
      : "https://" + window.location.hostname;

  const handelValmikiClick = (e?: any) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    handleVoiceBotClick();
  };

  return (
    <>
      <div className="templeApp">
        {/* {userInfo?.id ? <Header /> : null} */}
        {!isMobileView ? <Header ln={ln} /> : null}

        {/* TODO */}
        <div className="App">
          <OfflineDetector>
            <PageViewTracker />
            <PagePerformanceTracker />
            <ScrollTracker />
            <ScrollToTop />
            {/* ---- Shree Valmiki Voice Bot Trigger (Restricted to Home Page & Desktop) ---- */}
            {!isMobileView &&
              !isVoiceBotOpen &&
              !isShowAlertForLogin &&
              (location.pathname === "/" || location.pathname === "/home") && (
                <VoiceBotTriggerButton onClick={handleVoiceBotClick} />
              )}

            <Routes>
              <Route path="/apps" element={<AboutUsScreen />} />
              <Route path="*" element={<AboutUsScreen />} />
              <Route path="/error" element={<ErrorScreen />} />
              <Route path="/success" element={<SuccessScreen />} />
              <Route path="/offline" element={<OffLineScreen />} />

              {/* <Route path="/pageLink" element={<AboutUsScreen />} /> */}

              {/* Protected real application routes  and routes need to be handeled from setup routes according to prelogin ,post login and admin Screen*/}
              {/* TODO */}
              <Route element={<PrivateRoutes />}>
                <Route
                  path="/"
                  element={
                    <Suspense fallback={<HomeSkeleton isShowHeader={false} />}>
                      <HelmetComponent
                        metaData={{
                          title:
                            "Book Pandit Ji & Online Puja Services | Temple Dekho",
                          description:
                            "Book verified online puja services across India with TempleDekho. Find trusted pandits, book temples, and perform rituals easily with transparent pricing.",
                          imageUrl: metaTempleImg,
                          url: hostname + "/",
                        }}
                      >
                        <HomeScreen handelValmikiClick={handelValmikiClick} />
                      </HelmetComponent>
                    </Suspense>
                  }
                />

                <Route
                  path="/ai-valmiki"
                  element={
                    <Suspense fallback={<div>Loading...</div>}>
                      <HomeScreen handelValmikiClick={handelValmikiClick} />
                    </Suspense>
                  }
                />

                <Route path="/profile" element={<ProfileScreen />}>
                  <Route path="personalInfo" element={<PersonalInfoScreen />} />
                  <Route path="address" element={<AddressScreen />} />
                  {/* <Route path="payment" element={<PaymentInfoScreen />} />
                <Route path="family" element={<FamilyMembersScreen />} />
                <Route path="account" element={<AccountSettingsScreen />} /> */}
                </Route>
                <Route
                  path="/pujas"
                  element={
                    <HelmetComponent
                      metaData={{
                        title:
                          "India’s Trusted Platform to Book Pandit Ji Online | TempleDekho",
                        description:
                          "TempleDekho offers fast and reliable online puja booking across India. Find trusted pandits, book temples, and fulfil your spiritual needs with ease.",
                        imageUrl: metaTempleImg,
                        url: hostname + "/pujas",
                      }}
                      jsonLd={{
                        "@context": "https://schema.org",
                        "@graph": [PUJA_SCHEMA, PUJA_LIST_SCHEMA],
                      }}
                    >
                      <PujaScreen />
                    </HelmetComponent>
                  }
                />

                <Route
                  path="/pujaPackage"
                  element={
                    <HelmetComponent
                      metaData={{
                        title:
                          "Online Puja Booking at Famous Temples – Best Online Puja Services | Temple Dekho",
                        description:
                          "Temple Dekho offers trusted online puja services across India. Book online pujas at holy temples with prasad and blessings delivered to your doorstep. Experience divine peace from anywhere!",
                        imageUrl: metaTempleImg,
                        url: hostname + "/pujaPackage",
                      }}
                    >
                      <PujaPackageInfoscreen />
                    </HelmetComponent>
                  }
                />

                <Route
                  path="/chadavaPackage"
                  element={
                    <HelmetComponent
                      metaData={{
                        title:
                          "Online Puja Booking at Famous Temples – Best Online Puja Services | Temple Dekho",
                        description:
                          "Temple Dekho offers trusted online puja services across India. Book online pujas at holy temples with prasad and blessings delivered to your doorstep. Experience divine peace from anywhere!",
                        imageUrl: metaTempleImg,

                        url: hostname + "/chadavaPackage",
                      }}
                    >
                      <ChadavaPackageInfoScreen />
                    </HelmetComponent>
                  }
                />
                {/* <Route path="/puja-info" element={<PujaInfoScreen />} /> */}
                <Route
                  path="/templePujaList/:templeId"
                  element={<VirtualPujaBookingScreen keyType="id" />}
                />
                {/* Below is New route for templePuja list*/}
                <Route
                  path="/templePujas"
                  element={<VirtualPujaBookingScreen keyType="nameKey" />}
                />

                <Route
                  path="/temples/:templeId/pujaInfo/:pujaId"
                  element={<PujaInfoScreen keyType="id" />}
                />
                {/* Below is New route for Puja info*/}
                <Route
                  path="/templePujaInfo"
                  element={<PujaInfoScreen keyType="nameKey" />}
                />
                <Route
                  path="/temples"
                  element={
                    <HelmetComponent
                      metaData={{
                        title:
                          "Explore India’s Famous Temples & Iconic Hindu Mandirs",
                        description:
                          "Book trusted online puja services across India with TempleDekho. Hire verified pandits, book temples, and perform rituals easily from home.",
                        imageUrl: metaTempleImg,
                        url: hostname + "/temples",
                      }}
                    >
                      <TempleScreen />
                    </HelmetComponent>
                  }
                />
                <Route
                  path="/livedarshan"
                  element={
                    <HelmetComponent
                      metaData={{
                        title:
                          "Book Temple Darshan & E-Darshan Online Across India | TempleDekho",
                        description:
                          "Book verified online puja services across India with TempleDekho. Trusted pandits, easy temple booking, and complete spiritual solutions in one place.",
                        imageUrl: metaTempleImg,
                        url: hostname + "/livedarshan",
                      }}
                    >
                      <LiveDarshanScreen />
                    </HelmetComponent>
                  }
                />
                <Route
                  path="/astrology"
                  element={
                    <Suspense fallback={<SkeletonAnimations />}>
                      <HelmetComponent
                        metaData={{
                          title: "Astrology | Temple Dekho",
                          description:
                            "Get real-time astrology and spiritual guidance on Temple Dekho.",
                          imageUrl: metaTempleImg,
                          url: hostname + "/astrology",
                        }}
                      >
                        <GurujiScreen />
                      </HelmetComponent>
                    </Suspense>
                  }
                />
                <Route path="/horoscope" element={<HoroscopeScreen />} />
                <Route
                  path="/horoscopeDetails"
                  element={<HoroscopeDetailsScreen />}
                />
                <Route
                  path="/livedarshantemple/:id"
                  element={<LiveDarshanVideoScreen />}
                />
                <Route path="/panchang" element={<PanchangScreen />} />
                <Route
                  path="/specialTemples/:templeType"
                  element={<ShaktipethaScreen />}
                />
                <Route
                  path="/promotionalPuja/:id"
                  element={<PromotioanlPujaScreen keyType="id" />}
                />
                {/*New route for special puja*/}
                <Route
                  path="/specialPuja"
                  element={<PromotioanlPujaScreen keyType="nameKey" />}
                />

                {/*New route for special Chadhava*/}
                <Route
                  path="/specialChadhava"
                  element={<PromotionalChadhavaScreen keyType="nameKey" />}
                />

                <Route
                  path="/temples/:id"
                  element={<TempleDetailsScreen keyType="id" />}
                />
                {/*New route for templeInfo*/}
                <Route
                  path="/templeInfo"
                  element={<TempleDetailsScreen keyType="nameKey" />}
                />
                <Route
                  path="/pujaSubCategory/:id"
                  element={<PujaSubCategoriesScreen />}
                />
                {/* <Route path="/chadhavaTemples" element={<ChadhavaScreen />} /> */}
                <Route
                  path="/chadhavaTemples"
                  element={
                    <HelmetComponent
                      metaData={{
                        title:
                          "Book Online Chadhava Services Across India | TempleDekho",
                        description:
                          "Discover TempleDekho – your one-stop platform for online puja booking. Connect with expert pandits, book temples, and perform rituals hassle-free.",
                        imageUrl: metaTempleImg,
                        url: hostname + "/chadhavaTemples",
                      }}
                    >
                      <ChadhavaScreen />
                    </HelmetComponent>
                  }
                />
                <Route
                  path="/chadhavaDetails/:id"
                  element={<ChadhavaDetailsScreen />}
                />
                {/* <Route path="/prasadTemples" element={<PrasadScreen />} /> */}
                <Route
                  path="/prasadTemples"
                  element={
                    <HelmetComponent
                      metaData={{
                        title:
                          "Online Prasad Booking at Famous Temples – Best Online Prasad booking Services | Temple Dekho",
                        description:
                          "Temple Dekho offers trusted online Prasad services across India. Book online Prasad at holy temples blessings with delivery to your doorstep. Experience divine peace from anywhere!",
                        imageUrl: metaTempleImg,
                        url: hostname + "/prasadTemples",
                      }}
                    >
                      <PrasadScreen />
                    </HelmetComponent>
                  }
                />
                <Route
                  path="/prasadDetails/:id"
                  element={<PrasadDetailsScreen />}
                />
                {/* <Route path="/aiguruji" element={<AIGurujiHOD openModal={true} />} /> */}
                {/* <Route path="/checkout" element={<CheckoutScreen />}>
                <Route path="puja-details" element={<PujaDetailsScreen />} />
                <Route path="cart" element={<CartScreen />} />
              </Route> */}

                <Route path="/checkoutV2" element={<CheckoutV2Screen />}>
                  <Route
                    path="addDevotee"
                    element={<AddDevoteeDetailsScreen />}
                  />
                  <Route path="reviewCart" element={<ReviewCartScreen />} />
                </Route>
                {/* <Route path="/checkoutV3/cart" element={<CartV3Screen />}>

              </Route> */}
                {/* <Route path="/notification" element={<NotificationScreen />} /> */}
                <Route path="/search" element={<SearchScreen />} />
                <Route path="/search/category/:id" element={<SearchScreen />} />
                <Route path="/globalsearch" element={<GlobalSearchScreen />} />

                <Route path="/myOrders" element={<MyOrdersScreen />} />
                {/* <Route path="/order-details" element={<OrderDetailsScreen />} /> */}
                {/* Protected Admin routes */}

                <Route
                  path="/admin/*"
                  element={
                    <Suspense fallback={<SkeletonAnimations />}>
                      <AdminHandlerRoutes />
                    </Suspense>
                  }
                />

                {/* Routes AdminHandlerRoutes ends here */}
                <Route path="/nativeViews">
                  <Route
                    path="horoscope"
                    element={
                      <HoroscopeScreen setIsMobileView={setIsMobileView} />
                    }
                  />
                  <Route
                    path="horoscopeDetails"
                    element={
                      <HoroscopeDetailsScreen
                        setIsMobileView={setIsMobileView}
                      />
                    }
                  />
                  <Route
                    path="privacypolicy"
                    element={
                      <PrivacyPolicyScreen setIsMobileView={setIsMobileView} />
                    }
                  />
                  <Route
                    path="termsandconditions"
                    element={
                      <TermsAndConditionsScreen
                        setIsMobileView={setIsMobileView}
                      />
                    }
                  />
                  <Route
                    path="event"
                    element={<EventScreen setIsMobileView={setIsMobileView} />}
                  />
                  <Route
                    path="about"
                    element={<AboutScreen setIsMobileView={setIsMobileView} />}
                  />
                </Route>
              </Route>
              {/* Routes Redirect between Auth and Home */}
              <Route element={<AuthHandlerRoutes />}>
                <Route
                  path="/choose-profile"
                  element={<ChooseProfileScreen />}
                />
                <Route path="/login" element={<LoginScreen />} />
                {/* <Route path="/" element={<LoginScreen />} /> */}
                <Route path="/signup" element={<SignupScreen />} />
                <Route
                  path="/reset-password"
                  element={<ResetPasswordScreen />}
                />
              </Route>
              <Route path="/pagelink" element={<PageLinkScreen />} />
              <Route path="/privacypolicy" element={<PrivacyPolicyScreen />} />
              <Route
                path="/termsandconditions"
                element={<TermsAndConditionsScreen />}
              />
              <Route path="/contactus" element={<ContactUsScreen />} />
              <Route path="/about" element={<AboutScreen />} />
              <Route
                path="/refundscancellations"
                element={<RefundsCancellationsScreen />}
              />
              <Route
                path="/communityguidelines"
                element={<CommunityGuidelinesScreen />}
              />
              <Route path="/pujaSteps" element={<PujaStepsScreen />} />

              {/* Separate admin functionality in this route and separate auth ahndler need to be added*/}
            </Routes>
          </OfflineDetector>
          {/* <MobileAppPrompt
          open={isDialogOpen}
          onClose={handleClose}
          onDownload={handleDownload}
        /> */}
        </div>
        <Suspense fallback={<SkeletonAnimations />}>
          <AIGurujiLoginDialog
            openModal={isShowAlertForLogin}
            closeModal={closeAlertForLogin}
          />

          <ValmikiVoiceBotModal
            open={isVoiceBotOpen}
            onClose={handleVoiceBotClose}
            mobileLocation={mobileLocation}
          />

          <WalletModal />
        </Suspense>

        <BackToTop isMobileView={isMobileView} />
      </div>
    </>
  );
}

export default App;
